import connect from "../scripts/database.js";
import Axios from "axios";

export var Accounts = {
  getAccount(uid) {
    return new Promise(function(resolve, reject) {
      return connect.db
        .collection("users")
        .doc(uid)
        .get()
        .then(results => {
          if (results.exists) {
            let data = results.data();

            let accountInfo = {
              email: data.email,
              assignedRep: data.assignedRep || null,
              name: data.name,
              business: data.business,
              industry: data.industry,
              primaryIndustry: data.primaryIndustry || null,
              street: `${data.address.addressData.street_number} ${data.address.addressData.route}`,
              city: data.address.addressData.locality,
              state: data.address.addressData.administrative_area_level_1,
              postalCode: data.address.addressData.postal_code,
              country: data.address.addressData.country,
              countryAbbr: data.address.addressData.countryAbbr,
              phoneNumber: data.phoneNumber,
              taxExempt: data.taxExempt
            };

            resolve(accountInfo);
          } else {
            reject(false);
          }
        })
        .catch(error => {
          console.warn(error);
        });
    });
  },

  saveAccount(account) {
    this.translateToEnglish([account.industry, account.primaryIndustry || null])
      .then(industry => {
        connect.db
          .collection("users")
          .doc(account.uid)
          .update({
            name: account.name,
            business: account.business,
            industry: industry[0].translatedText, // English Translate
            primaryIndustry:
              industry[1].translatedText == "null"
                ? null
                : industry[1].translatedText, // English Translate
            address: {
              addressData: {
                administrative_area_level_1: account.state,
                country: account.country,
                countryAbbr: account.countryAbbr || null,
                locality: account.city,
                postal_code: account.postalCode,
                street_number: account.street,
                route: ""
              },
              string: `${account.street}, ${account.city}, ${account.state} ${account.postalCode}, ${account.country}`
            },
            phoneNumber: account.phoneNumber,
            taxExempt: account.taxExempt || false
          })
          .then(() => {
            this.updateProfileName(account.name);
          })
          .catch(error => {
            console.warn(error);
          });
      })
      .catch(err => {
        console.warn(err);
      });
  },

  createAccount(account) {
    return this.verifyInformation(account).then(results => {
      if (results === true) {
        return new Promise((resolve, reject) => {
          return connect.auth
            .createUserWithEmailAndPassword(account.email, account.password)
            .then(results => {
              this.updateProfileName(account.name);

              this.translateToEnglish([
                account.industry,
                account.primaryIndustry || null
              ])
                .then(industry => {
                  return connect.db
                    .collection("users")
                    .doc(results.user.uid)
                    .set({
                      name: account.name,
                      email: account.email,
                      business: account.business,
                      industry: industry[0].translatedText, // English Translate
                      primaryIndustry:
                        industry[1].translatedText == "null"
                          ? null
                          : industry[1].translatedText, // English Translate
                      address: {
                        addressData: {
                          administrative_area_level_1: account.state,
                          country: account.country,
                          countryAbbr: account.countryAbbr || null,
                          locality: account.city,
                          postal_code: account.postalCode,
                          street_number: account.street,
                          route: ""
                        },
                        string: `${account.street}, ${account.city}, ${account.state} ${account.postalCode}, ${account.country}`
                      },
                      phoneNumber: account.phoneNumber,
                      taxExempt: account.taxExempt || null
                    })
                    .then(() => {
                      account.uid = results.user.uid;
                      resolve(results.user.uid);
                    })
                    .catch(error => {
                      console.warn(error);
                      reject(error);
                    });
                })
                .catch(error => {
                  console.warn(error);
                  reject(error);
                });
            })
            .catch(err => {
              console.warn(err);
              reject(err);
            });
        });
      } else {
        return { errorMsg: "db/user-save-failed" };
      }
    });
  },

  verifyInformation(account) {
    return new Promise((resolve, reject) => {
      if (
        account.name.length > 0 &&
        account.password.length >= 6 &&
        this.validEmail(account.email) &&
        account.business.length > 0 &&
        account.industry.length > 0 &&
        account.state.length > 0 &&
        account.country.length > 0 &&
        account.city.length > 0 &&
        this.validPostalCode(account.postalCode) > 0 &&
        account.street.length > 0 &&
        this.validPhoneNumber(account.phoneNumber)
      ) {
        resolve(true);
      } else {
        reject(false);
      }
    });
  },

  validEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  },

  validPostalCode(postalCode) {
    var zip = postalCode;

    var us = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/; // USA
    var canada = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/; // Canada
    var uk = /^([A-Za-z]{1,2}\d[A-Za-z\d]? \d[A-Za-z]{2}|GIR 0AA)$/; // UK
    var australia = /^\d{4}$/; // Australia
    var multi = /^\d{5}$/; // France, Germany, Italy, Mexico
    var japan = /^\d{3}-\d{4}$/; // Japan
    var netherlands = /^\d{4} ?[A-Za-z]{2}$/; // Netherlands
    var brazil = /^\d{5}-\d{3}$/; // Brazil

    return (
      us.test(zip) ||
      canada.test(zip) ||
      uk.test(zip) ||
      australia.test(zip) ||
      multi.test(zip) ||
      japan.test(zip) ||
      netherlands.test(zip) ||
      brazil.test(zip)
    );
  },

  validPhoneNumber(phoneNumber) {
    if (
      /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(
        phoneNumber
      ) != false
    ) {
      return true;
    } else {
      return false;
    }
  },

  updateProfileName(value) {
    connect.auth.currentUser
      .updateProfile({
        displayName: value
      })
      .catch(error => {
        console.warn(error.code);
        console.warn(error.message);
      });
  },

  updateLastLogin(account) {
    connect.db
      .collection("users")
      .doc(account.uid)
      .update({
        lastLogin: Date.now()
      })
      .catch(err => {
        console.warn(err);
      });
  },

  /**
   * Translate multiple words to english
   * @param {Array} of words to translate
   * @return {Object} of words translated
   */
  translateToEnglish(words) {
    if (words.length > 0) {
      let query = "";

      for (var i in words) {
        if (words[i] && words[i].includes("&")) {
          query += `&q=${words[i].replace("&", "%26")}`; // Replace & with encode URI %26
        } else {
          query += `&q=${words[i]}`;
        }
      }

      return new Promise((resolve, reject) => {
        Axios.get(
          `https://translation.googleapis.com/language/translate/v2?key=AIzaSyDaSZa_Sit7xTk9fDgaHr4pR86OkEnVKIE&target=en${query}`
        )
          .then(results => {
            if (results.data.data.translations.length > 0) {
              let data = results.data.data.translations;
              resolve(data);
            }
          })
          .catch(err => {
            console.warn(err);
            reject(err);
          });
      });
    } else {
      return null;
    }
  }
};

export default Accounts;
